export const isValidISIN = (isin: string) => {
  if (!isin) return false;
  const ISIN_REGEX = /^[A-Z]{2}[A-Z0-9]{9}\d$/;
  if (ISIN_REGEX.exec(isin) === null) {
    console.log("Invalid ISIN", isin);
  }
  return ISIN_REGEX.exec(isin) !== null;
};
